<template>
  <div>

    <Dialog :visible.sync="exibirModalNovo" header="Mover Marcações" :modal="true" :style="{width: '450px'}" @hide="fecharModal">
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-12">
                <label>Data destino</label>	
                <Dropdown v-model="dataDestino" :options="datasDestinosMover" 
							optionLabel="nome" placeholder="Selecione"/>
            </div>            
        </div>  
        <DataTable :value="ponto.marcacoes" class="p-datatable-sm p-datatable-striped">           
            <Column field="selecionado" header="Selecionar">    
                <template #body="slotProps">
                    <Checkbox v-model="slotProps.data.selecionado" :binary="true"/>
                </template> 
            </Column>          
            <Column field="dataHora" header="Marcação">
                <template #body="slotProps">
                    {{ formatarDataHora(slotProps.data.dataHora) }}
                </template> 
            </Column>           
        </DataTable>    
        <h6 class="p-text-bold">Marcações do dia {{ dataPonto }}</h6>	       				
        <template #footer>
            <Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="fecharModal"/>
            <Button label="Salvar" icon="pi pi-check" @click="salvar" />
        </template>        
    </Dialog>
  </div>
</template>

<script>
import ControlePontoService from '@/service/ControlePontoService';
import { exibirMensagem, exibirMensagemSis, localeCalendarBR } from '@/global';
import { mapGetters } from 'vuex';

export default {
    controlePontoService: null,
    props: {
        callback: Function,
    },
    data() {
        return {
            dataPonto: null,
            exibirModalNovo: false,
            dataDestino: null,
            ponto: {marcacoes: []},
            datasDestinosMover: [],
            requisicao: {},
            localeCalendarBR: localeCalendarBR
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao']),
        /**
         * 
         * @param {*} req 
         */
        processar(req) {   
            this.dataDestino = null;
            this.requisicao = {...req};                     
            this.controlePontoService.buscarPontoMarcacoes(req)
            .then(resp => {                     
                this.ponto = resp.data;                
                let partesData = this.ponto.dia.split('-');
                let dataAtualPonto = new Date(Number(partesData[0]), (Number(partesData[1]) - 1), Number(partesData[2]));
                let umDia = 86400000;
                let ontem = new Date((dataAtualPonto.getTime() - umDia));
                let amanha = new Date((dataAtualPonto.getTime() + umDia));
                this.datasDestinosMover = [];
                this.datasDestinosMover.push({
                    nome: ontem.toLocaleDateString(),
                    valor: this.formatarData(ontem),
                    date: ontem
                });
                this.datasDestinosMover.push({
                    nome: amanha.toLocaleDateString(),
                    valor: this.formatarData(amanha),
                    date: amanha
                });
                this.dataPonto = this.formatarStringData(this.ponto.dia);
                this.exibirModalNovo = true;
            })
            .catch(erro => {exibirMensagem(this, erro)});            
        },        
        /**
         * 
         */
        salvar() {   
            let marcacoesSelecionadas = this.filtrarMarcacoes();  
            if(marcacoesSelecionadas.length == 0) {
                exibirMensagemSis(this, 'Selecione uma marcação para mover', true);
                return;
            }
            if(!this.dataDestino) {
                exibirMensagemSis(this, 'Selecione uma data para mover', true);
            } 
            this.requisicao['dataDestino'] = this.dataDestino.valor;
            this.requisicao['marcacoes'] = marcacoesSelecionadas;
            this.controlePontoService.moverMarcacoes(this.requisicao)
            .then(resp => {
                exibirMensagem(this, resp);		
                let dataMover = this.dataDestino.date;
                let partesDt = this.ponto.dia.split('-');
                let dataAtualPonto = new Date(Number(partesDt[0]), (Number(partesDt[1]) - 1), Number(partesDt[2]));
                if(dataMover.getTime() < dataAtualPonto.getTime()) {
                    this.callback(this.requisicao.dataDestino, this.ponto.dia);
                } else {
                    this.callback(this.ponto.dia, this.requisicao.dataDestino);
                }
                this.fecharModal(); 
            })
            .catch(erro => {                
                exibirMensagem(this, erro)
            });  
        },
        /**
         * 
         */
        filtrarMarcacoes() {
            let marcacoesSelecionadas = [];
            this.ponto.marcacoes.forEach(marcacao => {
                if(marcacao.selecionado) {
                    let marc = {...marcacao}                   
                    marcacoesSelecionadas.push(marc);
                }
            });
            return marcacoesSelecionadas;
        },
        /**
         * 
         * @param {*} strData 
         */
        formatarDataHora(strData) {            
            let partesData = strData.split(' ');
            let camposData = partesData[0].split('-');
            let data = camposData[2]+'/'+camposData[1]+'/'+camposData[0];
            let camposHora = partesData[1].split(':');            
            return data+' '+camposHora[0]+':'+camposHora[1];
        },  
        /**
         * 
         * @param {*} data 
         */
        formatarStringData(data) {
            if(!data || data instanceof Date) {
                return '';
            } 
            let partes = data.split('-');
            return partes[2] + '/' + partes[1] + '/' + partes[0];
        },   
        /**
         * 
         * @param {*} data 
         */
        formatarData(data) {
			if(!data) {
				return '';
			}
			let strData = null;
			let dt = data;
            let mes = dt.getMonth();
            let dia = dt.getDate();
            strData = dt.getFullYear() + '-' + ((mes + 1) < 10 ? '0'+(mes+1) : ''+(mes+1)) + '-' + (dia < 10 ? '0' + dia : '' + dia);
			return strData;
		},   
        /**
         * 
         */ 
        fecharModal() {
            this.exibirModalNovo = null;    
            this.ponto = {marcacoes: []};  
        }
    },
    created() {
        this.controlePontoService = new ControlePontoService();
    },    
}
</script>

<style>

</style>